"use client" // This is needed for client-side hooks like useState, useEffect, useRef

import { useEffect, useRef } from "react"
import "./SoftwareBenefits.css"

const ScopingBenefits = () => {
  const benefits = [
    {
      iconSrc: "/wpad.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Clear Guideline Icon",
      title: "THE RIGHT TECH STACK FOR YOUR PROJECT",
      description: "We’re fully invested in the growth of your business, using open-source and widely available technologies that offer up to 60% savings.",
    },
    {
      iconSrc: "/calci.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Plan Costs Icon",
      title: "95% PLANNING & ESTIMATION ACCURACY",
      description: "Our Agile Development Process lets you plan and manage realistic schedules, saving you time, and development costs.",
    },
    {
      iconSrc: "/target.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Business Plan Icon",
      title: "FOCUS ON YOUR GOALS",
      description: "Our project managers & software engineering team will advise you the best framework suitable for your project, create a roadmap with prioritized features, and set deadlines.",
    },
    {
      iconSrc: "/plan.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Focus Icon",
      title: "QUICK RAMP-UP",
      description:
        "Accelerate your time-to-market with a remarkable and responsive digital product, delivered 2x faster for immediate user testing.",
    },
  ]

  const headerRef = useRef(null)
  const descriptionRef = useRef(null)
  const cardRefs = useRef([]) // Use an array of refs for multiple cards

  useEffect(() => {
    console.log("ScopingBenefits component mounted. Setting up IntersectionObserver.")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            console.log(`Element ${entry.target.className} is now visible.`)
            observer.unobserve(entry.target) // Stop observing once visible
          }
        })
      },
      { threshold: 0.1 }, // Trigger when 10% of the element is visible
    )

    // Observe header and description
    if (headerRef.current) observer.observe(headerRef.current)
    if (descriptionRef.current) observer.observe(descriptionRef.current)

    // Observe each card
    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card)
    })

    return () => {
      console.log("ScopingBenefits component unmounted. Cleaning up IntersectionObserver.")
      // Clean up observers on unmount
      if (headerRef.current) observer.unobserve(headerRef.current)
      if (descriptionRef.current) observer.unobserve(descriptionRef.current)
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card)
      })
    }
  }, [])

  return (
    <div className="scoping-benefits-container" id="benefits">
      <div className="container">
      <div className="scoping-benefits-wrapper">
        {/* Header Section */}
        <div className="scoping-benefits-header3">
          <h2 className="scoping-benefits-title3 animate-left" ref={headerRef}>
           BUILD QUALITY AND 
            <br />
            DEBT-FREE
            <br />
            <span className="scoping-benefits-highlight"> DIGITAL PRODUCTS</span>
          </h2>
          <p className="scoping-benefits-description animate-left" ref={descriptionRef}>
            Build user-centric, customized and debt-free software solutions with a top-quality software development agency with a skilled team of software engineers, designers & data scientists.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="scoping-benefits-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="scoping-benefit-card animate-up"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ "--animation-delay": `${index * 0.1}s` }} // Staggered animation
            >
              <div className="scoping-benefit-icon">
                <img src={benefit.iconSrc || "/placeholder.svg"} alt={benefit.iconAlt} className="scoping-icon-image" />
              </div>
              <h3 className="scoping-benefit-card-title">{benefit.title}</h3>
              <p className="scoping-benefit-card-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingBenefits
